import { atom } from 'jotai'
import {
  requiredProperty,
  validateField,
  ValidatorReturn
} from '@sequencehq/utils/validation'
import { reviewPricingValidationAtom } from './reviewPricing.primitives.atoms'
import { phasesAtom } from './reviewPricing.atoms'

export const showValidationErrorsAtom = atom(
  get => {
    return get(reviewPricingValidationAtom).showValidationErrors
  },
  (_, set, showValidationErrors: boolean) => {
    set(reviewPricingValidationAtom, {
      showValidationErrors
    })
  }
)

export const priceValidationAtom = atom<Record<string, Array<ValidatorReturn>>>(
  get => {
    const phases = get(phasesAtom)
    const allPricesInPhases = phases.flatMap(phase => phase.allPrices)

    return allPricesInPhases.reduce((acc, price) => {
      return {
        ...acc,
        [price.id]: validateField(price)([requiredProperty('productId')])
      }
    }, {})
  }
)

export const stepIsValidAtom = atom(get => {
  const priceValidation = get(priceValidationAtom)

  const allPricesValid = Object.values(priceValidation).every(
    errors => errors.length === 0
  )

  return allPricesValid
})
